const aarData = [
  {
    id: 1,
    title: '36" Rumuekpe-Nkpoku Transmission Line',
    subtitle: "Split Sleeve Repair",

    type: "PIPELINE",
    year: "2026",
    area: "HSSE",
    status: "PUBLISHED",

    location: "KP 34 and KP 34.2",
    date: "27 March 2026",

    image: "/image 1.jpeg",

    tags: ["HSSE", "Quality", "Schedule"],

    overview:
      "The project involved the execution of split sleeve repair works on the 36 inch Rumuekpe-Nkpoku Transmission Line at KP 34 and KP 34.2.",

    performance: {
      safety: "Excellent",
      quality: "Good",
      cost: "On Budget",
      schedule: "Completed as Planned",
    },

    whatWentWell: [
      "Effective coordination between project teams.",
      "Strong adherence to HSSE requirements.",
      "Work activities were completed within the planned schedule.",
    ],

    improvements: [
      "Improve early identification of potential site constraints.",
      "Strengthen documentation of field observations.",
      "Improve communication of lessons learned across teams.",
    ],

    lessonsLearned: [
      "Early planning improves execution efficiency.",
      "Strong communication between disciplines reduces delays.",
      "Documenting lessons during execution improves future project planning.",
    ],

    actions: [
      {
        action: "Improve early site constraint identification",
        owner: "Project Team",
        dueDate: "30 April 2026",
        status: "OPEN",
      },
      {
        action: "Share lessons learned with relevant teams",
        owner: "Project Manager",
        dueDate: "15 April 2026",
        status: "COMPLETED",
      },
    ],
  },

  {
    id: 2,
    title: "Facility Upgrade Project",
    subtitle: "Mechanical & Piping Works",

    type: "FACILITY",
    year: "2026",
    area: "Quality",
    status: "PUBLISHED",

    location: "Rivers State",
    date: "15 February 2026",

    image: "/image 2.jpeg",

    tags: ["Execution", "Quality", "Cost"],

    overview:
      "The project covered mechanical and piping upgrade activities carried out as part of the facility improvement program.",

    performance: {
      safety: "Good",
      quality: "Excellent",
      cost: "On Budget",
      schedule: "Completed as Planned",
    },

    whatWentWell: [
      "Good coordination of mechanical activities.",
      "Quality requirements were maintained throughout execution.",
      "Resources were effectively managed.",
    ],

    improvements: [
      "Improve material planning.",
      "Strengthen progress reporting.",
    ],

    lessonsLearned: [
      "Early material planning reduces execution delays.",
      "Regular progress reviews improve project control.",
    ],

    actions: [
      {
        action: "Improve material forecasting",
        owner: "Procurement Team",
        dueDate: "30 March 2026",
        status: "OPEN",
      },
    ],
  },

  {
    id: 3,
    title: "Pipeline Integrity Repair",
    subtitle: "Pipeline Repair Works",

    type: "PIPELINE",
    year: "2026",
    area: "HSSE",
    status: "DRAFT",

    location: "Nigeria",
    date: "10 January 2026",

    image: "/image 3.jpeg",

    tags: ["HSSE", "Quality", "Execution"],

    overview:
      "Pipeline integrity repair activities carried out to address identified pipeline integrity requirements.",

    performance: {
      safety: "Good",
      quality: "Good",
      cost: "Under Review",
      schedule: "Under Review",
    },

    whatWentWell: [
      "HSSE controls were implemented during the work.",
      "Technical teams worked effectively together.",
    ],

    improvements: [
      "Improve pre-job planning.",
      "Increase documentation consistency.",
    ],

    lessonsLearned: [
      "Detailed pre-job planning improves execution readiness.",
    ],

    actions: [
      {
        action: "Standardize pre-job planning checklist",
        owner: "HSSE Team",
        dueDate: "30 May 2026",
        status: "OPEN",
      },
    ],
  },

  {
    id: 4,
    title: "Equipment Maintenance Project",
    subtitle: "Planned Maintenance",

    type: "MAINTENANCE",
    year: "2025",
    area: "Schedule",
    status: "UNDER REVIEW",

    location: "Nigeria",
    date: "22 December 2025",

    image: "/image 4.jpeg",

    tags: ["Schedule", "Cost", "Quality"],

    overview:
      "Planned maintenance activities undertaken to maintain equipment reliability and operational readiness.",

    performance: {
      safety: "Good",
      quality: "Good",
      cost: "On Budget",
      schedule: "Delayed",
    },

    whatWentWell: [
      "Maintenance activities were properly coordinated.",
      "Required technical resources were available.",
    ],

    improvements: [
      "Improve maintenance scheduling.",
      "Improve spare parts availability planning.",
    ],

    lessonsLearned: [
      "Maintenance planning should consider spare parts availability early.",
    ],

    actions: [
      {
        action: "Improve spare parts planning",
        owner: "Maintenance Team",
        dueDate: "20 January 2026",
        status: "OPEN",
      },
    ],
  },
];

export default aarData;